import type { Product } from "@jti/magento";

export const calculateLoyaltyCartPoints = (cartItems: Product[]): number =>
  cartItems.reduce((total, { points }: Product) => total + (points ?? 0), 0);
